import getStore from '../store/store';
import type { ObservableMap } from 'mobx';
import type FolderTreeData from '../store/schema/FolderTreeData';
import { getDefaultLogonEmailAddress } from 'owa-session-store';

/**
 * Selector for folder tree table for given mailbox smtp identity
 */
export default function getMailboxFolderTreeDataTable(
    userIdentity?: string
): ObservableMap<string, FolderTreeData> {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2532 (15,12): Object is possibly 'undefined'.
    // @ts-expect-error
    return getMailboxFolderTreeData(userIdentity).folderTreeTable;
}

export function getMailboxFolderTreeData(userIdentity: string) {
    if (!userIdentity) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (23,9): Type 'string | undefined' is not assignable to type 'string'.
        // @ts-expect-error
        userIdentity = getDefaultLogonEmailAddress();
    }

    return getStore().mailboxFolderTreeData.get(userIdentity);
}
